var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1266,
    height: 163,
    viewBox: "0 0 1266 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.689 2.81371C194.044 6.15695 211.084 17.5391 220.967 28.0082C251.965 60.8572 230.693 103.997 264.424 136.619C286.491 157.956 315.359 158.608 319.27 158.642C321.736 158.663 356.193 158.395 379.472 132.727C407.868 101.409 385.273 70.1592 413.628 34.5368C416.189 31.3171 439.736 2.64208 475.536 2.0105C506.869 1.4613 528.95 22.6261 531.252 24.9052C565.654 58.9075 541.498 100.482 575.989 135.294C578.516 137.848 600.611 159.294 633.082 159.493C636.493 159.514 666.169 159.253 688.798 137.457C723.324 104.203 698.297 62.3949 733.152 26.7382C736.247 23.5734 757.678 2.29883 788.861 2.1684C821.065 2.03796 843.283 24.7199 846.378 27.9739C879.521 62.8137 855.837 100.379 889.054 135.075C892.294 138.459 913.943 160.406 945.606 160.557C979.104 160.715 1001.69 136.379 1002.63 135.329C1031.78 102.919 1010.95 65.697 1042.48 30.3011C1046.89 25.3583 1057.47 13.7634 1075.29 7.4613C1086.28 3.57572 1096.1 3.09517 1102.51 3.28739",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M319.271 158.642C321.736 158.663 356.193 158.395 379.473 132.727C407.868 101.409 385.274 70.1592 413.628 34.5368C416.19 31.3171 439.737 2.64208 475.536 2.0105C506.87 1.4613 528.951 22.6261 531.252 24.9052C565.654 58.9075 541.498 100.482 575.99 135.294C578.517 137.848 600.611 159.294 633.082 159.493C636.493 159.514 666.17 159.253 688.798 137.457C723.324 104.203 698.298 62.3949 733.152 26.7382C736.248 23.5734 757.678 2.29883 788.862 2.1684",
    stroke: "#18E291",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M945.606 160.557C979.105 160.715 1001.69 136.379 1002.63 135.329C1031.78 102.919 1010.95 65.697 1042.48 30.3012C1046.89 25.3584 1057.47 13.7634 1075.29 7.46134C1086.28 3.57575 1096.1 3.0952 1102.51 3.28742",
    stroke: "#18E291",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.698 2.81372H123.733",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.474 2.81372H94.8105",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5301 2.81372H72.873",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6001 2.81372H53.6621",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8264 2.81372H35.0869",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8138 2.81372H18.5947",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.81372H3.46567",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1113.88 2.81372H1141.84",
    stroke: "#18E291",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.1 2.81372H1170.77",
    stroke: "#18E291",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.04 2.81372H1192.7",
    stroke: "#18E291",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1204.98 2.81372H1211.91",
    stroke: "#18E291",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1226.75 2.81372H1230.49",
    stroke: "#18E291",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.76 2.81372H1246.98",
    stroke: "#18E291",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.58 2.81372H1262.11",
    stroke: "#18E291",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.e3be86f7b61d91df16ac2a60af672f7d.svg";
export { ForwardRef as ReactComponent };